export enum PrinterType {
  HP = 'hp',
  Xerox = 'xerox',
}

export const PrinterTypeLabels: Record<PrinterType, string> = {
  [PrinterType.HP]: 'HP',
  [PrinterType.Xerox]: 'Xerox',
};

export const PrinterTypeOptions = Object.entries(PrinterTypeLabels).map(
  ([value, label]) => ({
    value: value as PrinterType,
    label,
  })
);
